import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Bell } from 'lucide-react'

export function NotificationsTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Notificacoes</CardTitle>
        <CardDescription>
          Configure suas preferencias de notificacao
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8 text-muted-foreground">
          <Bell className="h-12 w-12 mx-auto mb-4 opacity-50" />
          <p className="text-lg font-medium">Em breve</p>
          <p className="text-sm mt-1">
            Configuracoes de notificacao estarao disponiveis em uma atualizacao futura
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
